(function () {
	var path = window.location.pathname.replace(/\/$/, '') + '/';
	if (path === '/sitemap/') {
		document.body.classList.add('sitemap');
	}
})();
